import { MigrationSpec } from "../migration.models"

const aiMarketplaceProfiles: MigrationSpec = {
  type: "MIGRATE_AI_MARKETPLACE_PROFILES",
  collection: "AiProfile",
  risk: "DESTRUCTIVE",
  title: {
    en: "Marketplace settings → their own MARKETPLACE role",
    tr: "Pazaryeri ayarları → kendi MARKETPLACE rolüne"
  },
  description: {
    en:
      "Creates each customer's MARKETPLACE profile from the SERVICE or ECOMMERCE profile that " +
      "has marketplace channels configured (E-commerce wins where both do), unions every " +
      "marketplace channel onto it, then unsets `marketPlaceSettings` on the sources. From then " +
      "on a marketplace question is answered by the Marketplace role alone.",
    tr:
      "Pazaryeri kanalı tanımlı olan SERVICE veya ECOMMERCE profilinden müşterinin MARKETPLACE " +
      "profilini oluşturur (ikisi de tanımlıysa E-ticaret kazanır), tüm pazaryeri kanallarını " +
      "bu profilde birleştirir ve kaynaklardaki `marketPlaceSettings` alanını siler. Bundan " +
      "sonra pazaryeri sorularını yalnızca Pazaryeri rolü yanıtlar."
  },
  affectedFilter: {
    role: { $in: ["SERVICE", "ECOMMERCE"] },
    marketPlaceSettings: { $exists: true }
  },
  sampleFields: [
    "customer",
    "role",
    "marketPlaceSettings.status",
    "marketPlaceSettings.channels"
  ],
  preview: (doc) => {
    const { marketPlaceSettings, ...rest } = doc
    return {
      ...rest,
      // Not a field on this document — it shows where the block ends up.
      "→ new MARKETPLACE profile": { role: "MARKETPLACE", marketPlaceSettings }
    }
  },
  notes: [
    {
      en:
        "DESTRUCTIVE: the block is removed from the Service/E-commerce profile. Those roles stop " +
        "answering marketplace questions the moment this runs, so deploy qpien-ai and api-v2 first.",
      tr:
        "YIKICI: blok Hizmet/E-ticaret profilinden silinir. Bu çalıştığı anda o roller pazaryeri " +
        "sorularını yanıtlamayı bırakır; önce qpien-ai ve api-v2 deploy edilmelidir."
    },
    {
      en:
        "A profile whose block was never configured is cleared without creating anything — an " +
        "empty block would still make that role eligible the moment a channel was added to it.",
      tr:
        "Bloğu hiç yapılandırılmamış bir profilde blok yalnızca silinir, yeni profil açılmaz — " +
        "boş bir blok bile o role bir kanal eklendiği anda onu uygun hâle getirirdi."
    },
    {
      en: "Run BEFORE the guidance and skills migrations: they scope rules to the role this one creates.",
      tr: "Rehberlik ve Skill migration'larından ÖNCE çalıştırın: kuralları bu migration'ın açtığı role bağlarlar."
    },
    {
      en: "Requires MIGRATE_AI_PROFILE_ROLES to be APPLIED — the unique (customer, role) index.",
      tr: "MIGRATE_AI_PROFILE_ROLES'un APPLIED olmasını gerektirir — unique (customer, role) indeksi."
    }
  ]
}

export default aiMarketplaceProfiles
